// extracted by mini-css-extract-plugin
module.exports = {"details":"styles--details--3MT4z","actionButton":"styles--actionButton--3j-vn","mv":"styles--mv--3SW8I"};